import { Button, Flex, Stack, Text } from '@chakra-ui/react'
import type { CampaignDetailsSlugType, CampaignNavigationRecords } from '@twlvxtwlv/types'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { neueMachina } from '../../../../../../fonts'
import { ExternalNavigationButton } from '../../../../../shared/external-navigation-button'
import { SalesTypeIcon } from '../../../../../shared/icons/sales-type'

interface DetailsMenuProps {
  campaignNavigationRecords: CampaignNavigationRecords
  onChange: (slug: CampaignDetailsSlugType, productId: string | null) => void
  showFaqButton?: boolean
}

export function DetailsMenu({
  campaignNavigationRecords,
  onChange,
  showFaqButton = false,
}: DetailsMenuProps) {
  const { t } = useTranslation('campaign')
  const router = useRouter()
  return (
    <Stack spacing={0}>
      {Object.values(campaignNavigationRecords)
        .filter((record) => record && record.disabled !== true)
        .map((campaignNavigationRecord, index) => {
          const { productId, slug, titleTranslationKey, title, salesType, titleLeftElement } =
            campaignNavigationRecord
          const isActive = router.query.show === slug && router.query['product-id'] === productId
          return (
            <Button
              key={index}
              variant="txtWhite"
              minW="full"
              isActive={isActive}
              justifyContent="flex-start"
              alignItems="center"
              fontFamily={neueMachina.style.fontFamily}
              px={3}
              height={12}
              onClick={() => onChange(slug, productId ?? null)}
            >
              <Flex w="full" h="full" align="center" justify="flex-start" pl={2} gap={[2, 2]}>
                {titleLeftElement && (
                  <Text
                    fontFamily={neueMachina.style.fontFamily}
                    fontWeight="600"
                    textTransform="uppercase"
                  >
                    {titleLeftElement}
                  </Text>
                )}
                <Text
                  fontFamily={neueMachina.style.fontFamily}
                  fontWeight="400"
                  textTransform="uppercase"
                  textAlign="left"
                  w="100%"
                  overflowX="hidden"
                  overflowY="hidden"
                  textOverflow="ellipsis"
                >
                  {titleTranslationKey ? t(titleTranslationKey) : title}
                </Text>
                {salesType ? <SalesTypeIcon salesType={salesType} size="md" /> : null}
              </Flex>
            </Button>
          )
        })}
      {showFaqButton ? (
        <ExternalNavigationButton url="https://bit.ly/ddf-faq" buttonText="FAQs" />
      ) : null}
    </Stack>
  )
}
